import styled from '@emotion/styled'
import { getFlexbox } from '@helpers/mixins'

const FormattedValueContainer = styled.span<{
	width?: number
}>`
	${getFlexbox({ align: 'baseline', justify: 'flex-start' })}
	width: "max-content";
`

export { FormattedValueContainer }
